export default {
  FACTORIAL: 'FACTORIAL',
  PERSONIO: 'PERSONIO',
};
